<template>

  <b-card>
    <departamento-list
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :cabecalho="cabecalhoListagem"
      :info="info"
      :filtros="filtros"
    />
  </b-card>

</template>

<style lang="scss">
</style>

<script>
import api from '@/app-modulo/comuns/departamentos/shared/services/api'

export default {
  name: 'DepartamentosVisualizacao',
  components: {
    DepartamentoList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
  },
  data() {
    return {
      colunasListagem: [{ label: 'Nome', field: 'nome', editable: true }],
      filtros: [{ colunas: ['Nome'], valor: null }],
      cabecalhoListagem: { id: '', name: 'Nome' },
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
    }
  },
  methods: {
    carregar(page, pageSize, filtros) {
      return api.getDepartamentos(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-departamento' })
    },
    editar(value) {
      this.$router.push({ name: 'editar-departamento', params: { id: value.id } })
    },
    remover(itens) {
      const itensInner = itens
      return new Promise(resolve => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < itensInner.length; i++) {
          const item = itensInner[i]
          api.deleteDepartamento(item.id)
            .then(() => {
              // tenporario
              if (i === itensInner.length - 1) {
                resolve()
              }
            })
            .catch(err => {
              throw err
            })
        }
      })
    },
  },
}
</script>
